export default __webpack_public_path__ + "static/media/pin.1c955e05.svg";